import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    item: {
      packageItems: [],
      packagePromotions: [],
      packageDevices: [],
      title: '',
      description: '',
      dateFrom: null,
      dateTo: null
    },
    created: false,
    violations: {}
  },
  getters: {
    violations: state => state.violations,
    getCreated: state => state.created,
    getItem: state => state.item,
    getItemByIndex: state => index => state.item.packageItems[index],
    getTotalValueNetto (state, getters, rootState, rootGetters) {
      let totalValueNetto = 0
      state.item.packageItems.map(entry => {
        try {
          totalValueNetto += rootGetters['packages/list/getWarehouseItemById'](entry.item).priceNetto
        } catch (e) {}
      })
      return Math.round(totalValueNetto * 100) / 100
    },
    getTotalValueBrutto (state, getters, rootState, rootGetters) {
      let totalValueBrutto = 0
      state.item.packageItems.map(entry => {
        try {
          totalValueBrutto += rootGetters['packages/list/getWarehouseItemById'](entry.item).priceBrutto
        } catch (e) {}
      })
      return Math.round(totalValueBrutto * 100) / 100
    },
    getTotalVatAmount (state, getters, rootState, rootGetters) {
      let totalVatAmount = 0
      state.item.packageItems.map(entry => {
        try {
          let item = rootGetters['packages/list/getWarehouseItemById'](entry.item)
          totalVatAmount += (item.priceBrutto * item.vatRate.value) / (100 + item.vatRate.value)
        } catch (e) {}
      })
      return Math.round(totalVatAmount * 100) / 100
    }
  },
  mutations: {
    setCreated (state) {
      state.created = true
    },
    reset (state) {
      state.item = {
        packageItems: [],
        packagePromotions: [],
        packageDevices: [],
        title: '',
        description: '',
        dateFrom: null,
        dateTo: null
      }
      state.created = false
      state.violations = {}
    },
    setViolations (state, payload) {
      state.violations = payload
    }
  },
  actions: {
    async create ({ commit }, data) {
      data.packageItems = data.packageItems.map(entry => {
        return {
          item: entry.item,
          priceBrutto: entry.priceBrutto.toString(),
          priceNetto: entry.priceNetto.toString(),
          purchasePriceNetto: entry.purchasePriceNetto.toString()
        }
      })
      const response = await new ApiService('e_x_a_b_packages').post(data)
      if (response.status < 300) commit('setCreated', await response.json())
      else commit('setViolations', response)
    }
  }
}
